import { PaymentDTO } from '@/interface/CMC/cmcCredit';
import { LittleBank } from '@/interface/KKC/repayment';
import { creditApply as clCreditApply } from '@/pages/CL/credit/subpages/CreditProcess/interface';
import { creditApply } from '@/pages/CMC/credit/subpages/CreditProcess/interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
  creditApply: creditApply;
  withdrawlOrderId: string;
  stateHasChange: boolean;
  loanParams?: PaymentDTO;
  eddaCacheBank?: {
    bank: LittleBank;
    bankNum: string;
  }; // 缓存银行信息,放款因为Edda失败的情况下，直接展示这些缓存信息。
}

const initialState: CommonState | null = {
  creditApply: {
    id: '',
  },
  withdrawlOrderId: '',
  stateHasChange: false,
  loanParams: undefined,
};

const cmcCreditSlice = createSlice({
  name: 'cmcCredit',
  initialState,
  reducers: {
    setCreditApply(
      state: any,
      action: PayloadAction<{ creditApply: creditApply | clCreditApply }>
    ) {
      state.creditApply = action.payload.creditApply;
    },
    setWithdrawlOrderId(state: any, action: PayloadAction<{ orderId: string }>) {
      state.withdrawlOrderId = action.payload.orderId;
    },
    setStateHasChange(state: CommonState, action: PayloadAction<boolean>) {
      state.stateHasChange = action.payload;
    },
    setLoanParams(state: CommonState, action: PayloadAction<PaymentDTO | undefined>) {
      state.loanParams = action.payload;
    },
    setEddaCacheBank(
      state: CommonState,
      action: PayloadAction<{ bank: LittleBank; bankNum: string }>
    ) {
      state.eddaCacheBank = action.payload;
    },
    clearEddaCacheBank(state: CommonState) {
      state.eddaCacheBank = undefined;
    },
  },
});

const {
  setCreditApply,
  setWithdrawlOrderId,
  setStateHasChange,
  setLoanParams,
  setEddaCacheBank,
  clearEddaCacheBank,
} = cmcCreditSlice.actions;

export {
  setCreditApply,
  setWithdrawlOrderId,
  setStateHasChange,
  setLoanParams,
  setEddaCacheBank,
  clearEddaCacheBank,
};

export default cmcCreditSlice.reducer;
